import { ReviewEntryDetail } from '@/domain/entities/review/reviewEntryDetail'
import { ReviewEntryRepository } from '@/domain/repositories/review/reviewEntryRepository'

export class GetByEntryIdReviewListUseCase {
  constructor(private reviewEntryRepository: ReviewEntryRepository) {}

  async getByEntryIdReviews(entryId: string): Promise<ReviewEntryDetail[]> {
    try {
      return await this.reviewEntryRepository.getByEntryIdReviews(entryId)
    } catch (error) {
      console.error(`Error in GetByEntryIdReviewListUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
